$(document).ready(() => {
  function getAsyncData() {
    var get_batch_code = $("#purity-report-form-field").val();
    var resultContainer = $('#purity-report-form-result-container')[0];
    resultContainer.innerHTML = '';
    $.ajax({
      type: "GET",
      url: "https://purityreport.rowecasaorganics.com/Downlod_Report",
      data: { batch_code: String(get_batch_code) },
      success: function (response) {
        if (response != "sorry batchcode is not valid") {
          console.log(response);
          [...response.sl_document].map((item)=>{
            resultContainer.appendChild(createCardReport(item));
          });
        } else {
          let errorResult = document.createElement('p');
          errorResult.className='purity-report-form-result-error';
          errorResult.innerHTML='Invalid Batchcode';
          resultContainer.appendChild(errorResult);
        }
      },
    });
  }
  $('#purity-report-form-field').on('keypress',(e)=>{
    if(e.which == 13) getAsyncData();
  });
  $('#purity-report-form-field').on('keyup',(e)=>{
    var el = e.currentTarget;
    if(el.value.length){
      $('.purity-report-form-field-input-clear').show();
    }else{
      $('.purity-report-form-field-input-clear').hide();
    }
  })
  $('#purity-report-form-btn').on('click',(e)=>{
    getAsyncData();
  });
  $('.purity-report-form-field-input-clear').on('click',(e)=>{
    var el = e.currentTarget;
    $("#purity-report-form-field")[0].value='';
    $(el).hide();
  })
  function createCardReport(item){
    let cardContainer = document.createElement('div');
    cardContainer.className='purity-report-form-result-item';
    let cardImgContainer = document.createElement('div');
    cardImgContainer.className='purity-report-form-result-item-img';
    let cardImg = document.createElement('img');
    cardImg.src=item.sl_product_img;
    cardImg.loading='lazy';
    cardImgContainer.appendChild(cardImg);
    let cardInfoContainer = document.createElement('div');
    cardInfoContainer.className='purity-report-form-result-item-info';
    let cardTitle = document.createElement('div');
    cardTitle.className='purity-report-form-result-item-title';
    cardTitle.innerHTML=item.sl_product_title;
    let cardSubtext = document.createElement('div');
    cardSubtext.className='purity-report-form-result-item-subtext';
    cardSubtext.innerHTML='Batch Code: '+item.sl_products_batch;
    let cardBtn = document.createElement('a');
    cardBtn.className='purity-report-form-result-item-title-btn';
    cardBtn.innerHTML='Download';
    cardBtn.href=item.sl_product_doc;
    cardBtn.target='_blank';
    cardInfoContainer.appendChild(cardTitle);
    cardInfoContainer.appendChild(cardSubtext);
    cardInfoContainer.appendChild(cardBtn);
    cardContainer.appendChild(cardImgContainer);
    cardContainer.appendChild(cardInfoContainer);
    return cardContainer;
  }
});
